<script setup lang="ts">
import _service from "@/service";
import moment from 'moment'
import { closeToast, showLoadingToast } from "vant";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
const route = useRoute()
const detailData = ref({})
const {t} = useI18n()


const getDetail = async () => {
  showLoadingToast({
    duration: 0,
  });
  const {data} = await _service.getNoticeDetail({
    id:route.params.id
  })
  detailData.value = data
  closeToast()
}

onMounted(()=>{
  getDetail()
})
</script>

<template>
  <div class="notice-layout">
    <div class="title">{{detailData?.title}}</div>
    <div class="time" v-if="detailData.released_at">{{ moment(detailData?.released_at).format('YYYY-MM-DD HH:mm') }}</div>
    <div class="content" v-html="detailData?.content"></div>
  </div>
</template>

<style lang="scss" scoped>
.notice-layout {
  color: $text2;
  padding: 14px 16px;
  // text-align: center;
  font-weight: 800;
  font-family: 'Poppins', 'D-DINExp' !important;
  .title {
    color: $text1;
    font-size: 18px;
    font-weight: 500;
    text-align: left;
    line-height: 24px;
  }
  .time {
    color: $text2;
    font-size: 12px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    margin-bottom: 14px;
  }
  .content {
    color: $text1;
    font-size: 14px;
    font-weight: 800;
    line-height: 24px;
    font-weight: 800;
    :deep(p){
      min-height: 1em;
    }
    :deep(h1){
      color: $text1 !important;
      line-height: 1.3;
      margin-bottom: .5em;
    }
    :deep(h2){
      color: $text1;
      margin-bottom: .5em;
    }
    :deep(h3){
      color: $text1;
      margin-bottom: .5em;
    }
    :deep(h4){
      color: $text1;
      margin-bottom: .5em;
    }
    :deep(h5){
      color: $text1;
      margin-bottom: .5em;
    }
    :deep(h6){
      color: $text1;
      margin-bottom: .5em;
    }
    
  }
  :deep(img) {
    width: 100%;
    height: 100%;
  }
}

</style>
